/**
 * @module views\mdl\environment
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import { Watch, Mixins } from "vue-property-decorator";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import { TreeNode } from "element-ui/types/tree";
import StructureNavigation from "@/businessComponents/mdl/structureNavigation/structureNavigation.vue";
import StructureSelector from "@/businessComponents/mdl/structureSelector/structureSelector.vue";
import DependedStructure from "../dependedStructure/dependedStructure";

@Component
export default class Environment extends Mixins(DependedStructure) {
  protected module = "mes.business.mdl.environment.service";

  protected cls = "EnvironmentService";
}
